import { ParentPublisherTable } from './parent-publisher-table';

export { ParentPublisherTable };
